// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3wxh9","header":"ReportDetails_header__3cnqd","title":"ReportDetails_title__31uZM","left":"ReportDetails_left__1JxeF"};